module.exports = __webpack_public_path__ + "static/media/attachment-from-dropbox.d281474c.svg";